import React from 'react';
import Style from './style.sass';

const Slider = ({label, min, max, value, unit, onChange}) => {
  return (
    <div className={Style.Filter__slider}>
      <div className={Style.Filter__sliderLabel}>
        <label>{label}</label>
        <div>
          <input className={Style.Filter__sliderSize} type='number' min={min} max={max} value={value} onChange={onChange}/>
          <span className={Style.Filter__sliderUnit}>{unit}</span>
        </div>
      </div>
      <div className={Style.Filter__sliderBody}>
        <input type='range' min={min} max={max} value={value} onChange={onChange}/>
        <div className={Style.Filter__reset} onClick={onChange}>リセット</div>
      </div>
    </div>
  );
}
export default Slider;